export enum EmployeeActions {
  Toggled = 'toggled',
  PageChange = 'pageChange',
  ManageDependants = 'manageDependants'
}